import { testActionType, testType } from "../../common";

const initState: testType = [
  { id: 1, name: "zs", flag: false },
  { id: 2, name: "ls", flag: false },
  { id: 3, name: "ww", flag: true },
];

export default function test(preState = initState, action: testActionType) {
  switch (action.type) {
    case "home/delete":
      return preState.filter((item) => item.id !== action.payLoad);
    case "home/add":
      return [action.payLoad, ...preState];
    case "home/edit":
      return preState.map((item) => {
        if (item.id === action.payLoad) {
          return {
            ...item,
            flag: !item.flag,
          };
        }
        return item;
      });
    default:
      return preState;
  }
}
